<div [ngClass]="{  'p-6': !isHandset() }">
    <!-- Header Section -->
    <div class="flex justify-between items-center mb-6">
        @if (isHandset()) {
        <h3 class="text-lg font-semibold text-gray-900">Parking Management</h3>
        }
        @else {
        <h1 class="text-2xl font-semibold text-gray-900">Parking Management</h1>
        }

        <!-- Action Buttons -->
        <div class="flex items-center gap-2">
            <!-- Filter Button -->
            @if (isHandset()) {
            <button mat-icon-button (click)="openFilterDialog()" title="Filter parking spaces"
                [attr.aria-label]="'Filter parking spaces'" class="filter-button">
                <mat-icon>filter_list</mat-icon>
            </button>
            }
            @else {
            <jjames-button variant="secondary" (clicked)="openFilterDialog()" iconLeft="fas fa-filter"
                class="filter-button" matIconLeft="filter_list">
                Filters
            </jjames-button>
            }

            @if(isAdmin()) {
            <!-- Create Button -->
            @if (isHandset()) {
            <button mat-fab color="primary" (click)="onCreateParkingArea()" title="New parking area"
                [attr.aria-label]="'New parking area'" class="enhanced-fab">
                <mat-icon class="enhanced-icon">add</mat-icon>
            </button>
            }
            @else {
            <jjames-button variant="primary" (clicked)="onCreateParkingArea()" class="enhanced-button"
                matIconLeft="add">
                New parking area

            </jjames-button>
            }
            }
        </div>
    </div>

    <!-- Search Bar -->
    <div class="mb-4">
        <div class="relative">
            <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <mat-icon class="text-gray-400 text-lg leading-none">search</mat-icon>
            </div>
            <input type="text" [ngModel]="searchTerm()" (ngModelChange)="onSearch($event)" placeholder="Search by name…"
                class="block w-full rounded-lg border border-gray-300 bg-white py-2 pl-10 pr-10 text-sm text-gray-900 placeholder-gray-400 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500" />
            @if (searchTerm()) {
            <button type="button" (click)="clearSearch()"
                class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600">
                <mat-icon class="text-lg leading-none">close</mat-icon>
            </button>
            }
        </div>
    </div>

    <!-- Content Section -->
    <div class="space-y-6">
        <!-- Loading State -->
        @if (isLoading) {
        <div class="flex flex-col items-center justify-center py-12 space-y-4">
            <mat-spinner diameter="50" class="custom-spinner"></mat-spinner>
            <div class="text-center">
                <h3 class="text-lg font-medium text-gray-900 mb-2">Loading parking areas...</h3>
                <p class="text-gray-500">Please wait while we fetch your parking data.</p>
            </div>
        </div>
        }
        <!-- Parking Areas List -->
        @else if (filteredSpaces().length > 0) {
        <div class="space-y-6">
            <!-- Use existing parking-space-list component -->
            <app-parking-space-list [parkingSpaces]="filteredSpaces()" [paginationConfig]="pagination"
                (pageChange)="onPageChange($event)" (parkingSpaceDeleted)="onParkingSpaceDeleted($event)">
            </app-parking-space-list>
        </div>
        } @else if (searchTerm()) {
        <!-- No search results -->
        <jjames-card class="text-center py-12">
            <div class="flex flex-col items-center space-y-4">
                <mat-icon class="h-16 w-16 text-gray-400 text-6xl">search_off</mat-icon>
                <div class="space-y-2">
                    <h3 class="text-lg font-medium text-gray-900">No results for "{{ searchTerm() }}"</h3>
                    <p class="text-gray-500">Try a different name or clear the search.</p>
                </div>
            </div>
        </jjames-card>
        } @else {
        <!-- Empty State -->
        <jjames-card class="text-center py-12">
            <div class="flex flex-col items-center space-y-4">
                <svg class="h-16 w-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                <div class="space-y-2">
                    <h3 class="text-lg font-medium text-gray-900">No parking areas created yet</h3>
                    <p class="text-gray-500 max-w-sm">Get started by creating your first parking area to manage your
                        parking spaces efficiently.</p>
                </div>
                <jjames-button variant="primary" (clicked)="onCreateParkingArea()" iconLeft="fas fa-plus">
                    Create your first parking area
                </jjames-button>
            </div>
        </jjames-card>
        }
    </div>
</div>